<template>

  <div class="home">

    <LayoutTopComponent></LayoutTopComponent>

    <div class="service_top">
      <img src="../assets/images/service_top.png">
    </div>

    <div class="service_center">
      <div class="service_center_top">
        <img src="../assets/images/service_center_002.png">
      </div>
      <div class="service_center_bottom">
        <div class="bottom_left">
          <img src="../assets/images/service_center_001.png">
        </div>
        <div class="bottom_right">
          <div class="bottom_right_body">
            <div class="right_body_item_a">杭州富从智能技术有限公司</div>
            <div class="right_body_item_b">地址：杭州市拱墅区新文路33号天堂e谷4号楼220室</div>
            <div class="right_body_item_b">销售联系：13376821181</div>
            <div class="right_body_item_b">售后联系：18958019503</div>
            <div class="right_body_item_b">合作邮箱：342029782@qq.com</div>
          </div>
        </div>
      </div>

    </div>

    <div class="service_bottom">
      <div class="service_bottom_title">
        <div class="bottom_title_icon"></div>
        <div class="bottom_title">智能引领未来</div>
        <div class="bottom_title_icon"></div>
      </div>
      <div class="service_bottom_body">
        专做智能，多种便民功能非常实用，批量生产，出厂价直销
      </div>
    </div>

    <LayoutBottomComponent></LayoutBottomComponent>

  </div>

</template>


<script>

import LayoutTopComponent from '../components/LayoutTopComponent'
import LayoutBottomComponent from '../components/LayoutBottomComponent'

export default {
  data() {
    return {}
  },
  components: {
    LayoutTopComponent,
    LayoutBottomComponent
  },
  methods: {}

}
</script>

<style lang="less" scoped>

@import "../assets/css/common";

@media screen and (max-width: 1280px) {
  .home {
    width: @screenWidth1280;
    margin-top: @layoutTopHight1280;

    .service_top {
      height: @viewPager1280;
    }
  }
}

@media screen and (min-width: 1281px) and (max-width: 1440px) {
  .home {
    width: @screenWidth1440;
    margin-top: @layoutTopHight1440;

    .service_top {
      height: @viewPager1440;
    }
  }
}

@media screen and (min-width: 1441px) and (max-width: 1920px) {
  .home {
    width: @screenWidth1920;
    margin-top: @layoutTopHight1920;

    .service_top {
      height: @viewPager1920;
    }
  }
}

.home {
  display: flex;
  flex-direction: column;

  .service_top {
    display: flex;
    width: 100%;
  }

  .service_center {
    display: flex;
    flex-direction: column;

    .service_center_top {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 45px;
      margin: 113px 0 60px 0;
    }

    .service_center_bottom {
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 0 0 60px 0;

      .bottom_left {
      }

      .bottom_right {
        display: flex;
        margin-left: 28px;

        .bottom_right_body {
          display: flex;
          flex-direction: column;
          align-items: flex-start;

          .right_body_item_a {
            margin-bottom: 12px;
            font-size: 24px;
            font-family: Source Han Sans CN;
            font-weight: 500;
            color: #2A57EA;
            line-height: 22px;
          }

          .right_body_item_b {
            font-size: 18px;
            font-family: Source Han Sans CN;
            font-weight: 500;
            color: #2A57EA;
            line-height: 48px;
          }
        }

      }
    }

  }

  .service_bottom {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin: 16px 0;

    .service_bottom_title {

      display: flex;
      justify-content: center;
      align-items: center;

      .bottom_title {

        font-size: 30px;
        font-family: Source Han Sans CN;
        font-weight: 500;
        color: #626262;
        line-height: 48px;

      }

      .bottom_title_icon {
        width: 16px;
        height: 16px;
        margin: 12px;
        background: url("../assets/images/service_bottom_icon.png");
      }
    }

    .service_bottom_body {


      font-size: 16px;
      font-family: Source Han Sans CN;
      font-weight: 500;
      color: #626262;
      line-height: 48px;

    }

  }

}
</style>

